import React, { useEffect, useState } from 'react';
import { GetAIEmbedURLUseCase, GetAIEmbedURLUseCaseName } from '../../../domain/use_cases/ai/GetAIEmbedURLUseCase';
import di from '../../../di/DependencyInjection';

import "./AiPage.scss"

const AiPageDashNegativeSentiment: React.FC = () => {
    const [embededURL, setEmbededURL] = useState('');
    const [isUpdating, setIsUpdating] = useState(false);

    const _updateUserRoleById = async () => await di.get<GetAIEmbedURLUseCase>(GetAIEmbedURLUseCaseName).call('negative_sentiment');

    const _firstCall = async () => {
        setIsUpdating(true);
        const response = await _updateUserRoleById();
        if (response._tag === "Right") {
            let result = JSON.parse(response.right);
            if (result && result.data) {
                setEmbededURL(result.data);
            }
        }
        setIsUpdating(false);
    };

    useEffect(() => {
        _firstCall();
    }, []);

    return (
        <div className='experience_container_body'>
            {isUpdating && (
                <div className="updating-message-container">
                    <p>Updating dashboard...</p>
                </div>
            )}
            {!isUpdating && (
                <iframe
                src={embededURL}
                className="experience_container"
                style={{ width: '100%', height: '700px', display: isUpdating ? 'none' : 'block' }}
            ></iframe>
            )}
        </div>
    );
};

export default AiPageDashNegativeSentiment;
